/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetIntegrationsConfig200ResponseAutotaskPriorities
 */
export interface GetIntegrationsConfig200ResponseAutotaskPriorities {
    /**
     * 
     */
    critical: number;
    /**
     * 
     */
    high: number;
    /**
     * 
     */
    medium: number;
    /**
     * 
     */
    low: number;
    /**
     * 
     */
    info: number;
}

/**
 * Check if a given object implements the GetIntegrationsConfig200ResponseAutotaskPriorities interface.
 */
export function instanceOfGetIntegrationsConfig200ResponseAutotaskPriorities(value: object): value is GetIntegrationsConfig200ResponseAutotaskPriorities {
    if (!('critical' in value) || value['critical'] === undefined) return false;
    if (!('high' in value) || value['high'] === undefined) return false;
    if (!('medium' in value) || value['medium'] === undefined) return false;
    if (!('low' in value) || value['low'] === undefined) return false;
    if (!('info' in value) || value['info'] === undefined) return false;
    return true;
}

export function GetIntegrationsConfig200ResponseAutotaskPrioritiesFromJSON(json: any): GetIntegrationsConfig200ResponseAutotaskPriorities {
    return GetIntegrationsConfig200ResponseAutotaskPrioritiesFromJSONTyped(json, false);
}

export function GetIntegrationsConfig200ResponseAutotaskPrioritiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIntegrationsConfig200ResponseAutotaskPriorities {
    if (json == null) {
        return json;
    }
    return {
        
        'critical': json['critical'],
        'high': json['high'],
        'medium': json['medium'],
        'low': json['low'],
        'info': json['info'],
    };
}

export function GetIntegrationsConfig200ResponseAutotaskPrioritiesToJSON(json: any): GetIntegrationsConfig200ResponseAutotaskPriorities {
    return GetIntegrationsConfig200ResponseAutotaskPrioritiesToJSONTyped(json, false);
}

export function GetIntegrationsConfig200ResponseAutotaskPrioritiesToJSONTyped(value?: GetIntegrationsConfig200ResponseAutotaskPriorities | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'critical': value['critical'],
        'high': value['high'],
        'medium': value['medium'],
        'low': value['low'],
        'info': value['info'],
    };
}

